<script>
export default {
  name: "banner"
}
</script>

<template>
  <div class="banner">
    <div class="banner__title">Estrena un auto nuevo</div>
    <div class="banner__title banner__title--secondary">de cualquier marca con un solo trámite</div>
    <div class="banner__tip">
      <img class="banner__tip-icon" src="@/assets/imgs/banner-tip-icon.svg"/>
      Regulados por PROFECO
    </div>
  </div>
</template>

<style scoped lang="less">
.banner {
  position: relative;
  height: 8.25rem;
  background: url("@/assets/imgs/banner-bg.webp") no-repeat;
  background-size: cover;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.banner__title{
  position: relative;
  color: #FFF;
  font-family: "Cal Sans";
  font-size: 1.1875rem;
  line-height: 1.5rem;
  &.banner__title--secondary{
    margin: 0.25rem 0 1rem 0;
  }
}

.banner__tip{
  position: relative;
  display: flex;
  align-self: flex-start;
  align-items: center;
  color: #000;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.25rem;
  border-radius: 0.25rem;
  background: rgba(255, 255, 255, 0.80);
  padding: 0 0.25rem;
  .banner__tip-icon{
    margin-right: 0.25rem;
  }
}

</style>